import Clerk from './Clerk'
import DunningProcedure from './DunningProcedure'
import DunningBlock from './DunningBlock'
import EligibilityIndicator from './EligibilityIndicator'
import PaymentTerm from './PaymentTerm'
import SelectionRule from './SelectionRule'
import CreditHoldAction from './CreditHoldAction'

export class AccountingInfo {
    RequestID: number;
    AccountingClerkID?: number;
    DunningClerkID?: number;
    DunningProcedureID?: number;
    DunningBlockID?: number;
    EligibilityIndicatorID?: number;
    PaymentTermID?: number;
    SelectionRuleID?: number;
    AccountingClerk?: Clerk;
    DunningClerk?: Clerk;
    DunningProcedure?: DunningProcedure;
    DunningBlock?: DunningBlock;
    EligibilityIndicator?: EligibilityIndicator;
    PaymentTerm?: PaymentTerm;
    SelectionRule?: SelectionRule;
    CreditHoldActionID?: number;
    CreditHoldAction?: CreditHoldAction;
}

export default AccountingInfo;